import { cloneDeep } from 'lodash-es'

const initialState = {}

function buildSelectedIds(selectedIds, selected, itemId) {
  const ids = selectedIds || []
  if (selected) {
    return ids.includes(itemId) ? ids : [...ids, itemId]
  }
  return ids.filter((id) => id !== itemId)
}

function selectedItemsToSelectedIds(selectedItems, selected = true, selectedIds = {}) {
  const newSelectedIds = { ...selectedIds }
  const items = selectedItems || []

  items.forEach((item) => {
    newSelectedIds[item.group.key] = buildSelectedIds(
      newSelectedIds[item.group.key],
      selected,
      item.id
    )
  })
  return newSelectedIds
}

const rebuildGroupCollection = (state, filterName, groupKey, items) => (
  state[filterName].groups.collection.map((group) => (
    (group.key === groupKey) ? {
      ...group,
      items: {
        collection: group.items.collection.concat(items.collection),
        pagination: items.pagination
      }
    } : group
  ))
)

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_FILTER_BOOTSTRAP_REQUEST': {
      const oldFilter = state[action.payload.name]
      const newFilter = {
        ...oldFilter,
        status: 'loading'
      }
      return {
        ...state,
        [action.payload.name]: newFilter
      }
    }
    case 'CLEAR_FILTER_BOOTSTRAP':
      return {
        ...state,
        [action.payload.name]: null

      }
    case 'FETCH_FILTER_BOOTSTRAP_DONE': {
      const oldFilter = state[action.payload.name]

      const newFilter = {
        ...oldFilter,
        status: 'ready',
        selected_items: action.payload.selected_items,
        groups: action.payload.groups,
        initial_selected_ids: action.payload.initial_selected_ids
      }
      if (!newFilter.selected_ids) {
        newFilter.selected_ids = action.payload.initial_selected_ids
      }

      return {
        ...state,
        [action.payload.name]: newFilter
      }
    }
    case 'FETCH_FILTER_ITEMS_DONE': {
      const filter = state[action.payload.name]

      const newFilter = {
        ...filter,
        groups: {
          ...filter.groups,
          collection: rebuildGroupCollection(
            state,
            action.payload.name,
            action.payload.group.key,
            action.payload.items
          )
        }
      }

      return {
        ...state,
        [action.payload.name]: newFilter
      }
    }
    case 'FETCH_FILTER_GROUPS_DONE': {
      const filter = state[action.payload.name]

      const newFilter = {
        ...filter,
        groups: {
          collection: filter.groups.collection.concat(action.payload.groups.collection),
          pagination: action.payload.groups.pagination
        }
      }

      return {
        ...state,
        [action.payload.name]: newFilter
      }
    }
    case 'SET_FILTER_ITEM': {
      const oldFilter = state[action.payload.name]
      const oldGroupIds = oldFilter.selected_ids[action.payload.groupKey] || []
      const newGroupIds = buildSelectedIds(oldGroupIds, action.payload.selected, action.payload.itemId)

      const newSelectedIds = {
        ...oldFilter.selected_ids,
        [action.payload.groupKey]: newGroupIds
      }

      const newFilter = {
        ...oldFilter,
        selected_ids: newSelectedIds
      }

      return {
        ...state,
        [action.payload.name]: newFilter
      }
    }
    case 'SET_ALL_FILTER_ITEMS': {
      const oldFilter = state[action.payload.name]

      const newSelectedIds = selectedItemsToSelectedIds(
        oldFilter.selected_items,
        action.payload.selected,
        oldFilter.selected_ids
      )

      oldFilter.groups.collection.forEach((group) => {
        group.items.collection.forEach((item) => {
          newSelectedIds[group.key] = buildSelectedIds(
            newSelectedIds[group.key],
            action.payload.selected,
            item.id
          )
        })
      })

      const newFilter = {
        ...oldFilter,
        selected_ids: newSelectedIds
      }

      return {
        ...state,
        [action.payload.name]: newFilter
      }
    }
    case 'BULK_DISABLE_FILTER_ITEMS': {
      const { filterName, groupsToETs } = action.payload
      const oldFilter = state[filterName]
      const newFilter = cloneDeep(oldFilter)

      newFilter.groups.collection = newFilter.groups.collection.map((group) => {
        const etIds = groupsToETs[group.key]

        if (Object.keys(etIds)?.length < 1) { return group }

        const newCollection = group.items.collection.map((et) => {
          if (etIds[et.id]) {
            return { ...et, disabled: true }
          }
          return et
        })

        return {
          ...group,
          items: {
            ...group.items,
            collection: newCollection
          }
        }
      })

      return {
        ...state,
        [filterName]: newFilter
      }
    }
    default:
      return state
  }
}
